import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import InputLabel from "@mui/material/InputLabel";
import classnames from "classnames";
import { Box } from "../../../Box/index.js";
import { Typography } from "../../../Typography/index.js";
import Label_styles from "./Label.styles.js";
const Label = (t0)=>{
    const $ = c(25);
    const { label, tooltip: t1, color: t2, icon, variant: t3, required: t4, className, inputId, row: t5 } = t0;
    const tooltip = void 0 === t1 ? null : t1;
    const color = void 0 === t2 ? "text.light.secondary" : t2;
    const variant = void 0 === t3 ? "body3" : t3;
    const required = void 0 === t4 ? false : t4;
    const row = void 0 === t5 ? false : t5;
    let t6;
    if ($[0] !== row) {
        t6 = {
            row
        };
        $[0] = row;
        $[1] = t6;
    } else t6 = $[1];
    const { classes } = Label_styles(t6);
    const t7 = classes.labelBox;
    let t8;
    if ($[2] !== className || $[3] !== classes.label) {
        t8 = classnames(classes.label, className, "aqa_input_label");
        $[2] = className;
        $[3] = classes.label;
        $[4] = t8;
    } else t8 = $[4];
    const t9 = required ? classes.required : "";
    let t10;
    if ($[5] !== color || $[6] !== label || $[7] !== t9 || $[8] !== variant) {
        t10 = /*#__PURE__*/ jsx(Typography, {
            className: t9,
            color: color,
            variant: variant,
            children: label
        });
        $[5] = color;
        $[6] = label;
        $[7] = t9;
        $[8] = variant;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== inputId || $[11] !== t10 || $[12] !== t8) {
        t11 = /*#__PURE__*/ jsx(InputLabel, {
            className: t8,
            htmlFor: inputId,
            shrink: true,
            children: t10
        });
        $[10] = inputId;
        $[11] = t10;
        $[12] = t8;
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    if ($[14] !== tooltip) {
        t12 = /*#__PURE__*/ jsx(Box, {
            ml: "8",
            maxHeight: 20,
            children: tooltip
        });
        $[14] = tooltip;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t11 || $[17] !== t12) {
        t13 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            children: [
                t11,
                t12
            ]
        });
        $[16] = t11;
        $[17] = t12;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== icon) {
        t14 = icon && /*#__PURE__*/ jsx(Box, {
            children: icon
        });
        $[19] = icon;
        $[20] = t14;
    } else t14 = $[20];
    let t15;
    if ($[21] !== classes.labelBox || $[22] !== t13 || $[23] !== t14) {
        t15 = /*#__PURE__*/ jsxs(Box, {
            className: t7,
            children: [
                t13,
                t14
            ]
        });
        $[21] = classes.labelBox;
        $[22] = t13;
        $[23] = t14;
        $[24] = t15;
    } else t15 = $[24];
    return t15;
};
export { Label };
